module.exports = __webpack_public_path__ + "static/media/fisdom_logo_white.b228f458.svg";